// VITE_API_KEY is deliberately bundled into the browser for direct API calls.
export function createApiFetch(apiKey, fetchImpl = (...args) => globalThis.fetch(...args)) {
  return (input, options = {}) => {
    const requestHeaders = typeof Request !== 'undefined' && input instanceof Request
      ? input.headers : undefined
    const headers = new Headers(options.headers ?? requestHeaders)
    if (apiKey && !headers.has('x-api-key')) headers.set('x-api-key', apiKey)
    return fetchImpl(input, { ...options, headers })
  }
}

export const apiFetch = createApiFetch(import.meta.env?.VITE_API_KEY)
